import React, { useState, useEffect } from "react";
import { Field } from "formik";

export const CheckAllBox = ({ formik }) => {
    useEffect(() => {
        formik.setFieldValue('facilitiesGroupAll', 0);
    }, []);

    useEffect(() => {

        let facGroupCount = formik.values.facilitiesGroup?.filter((key) => key !== "otherFac").length || 0;
        let facGroupAllCount = formik.values.facilitiesGroupAllList?.length || 0;

        if (facGroupCount > 0 && facGroupCount === facGroupAllCount) {
            formik.setFieldValue('facilitiesGroupAll', true);
        } else {
            formik.setFieldValue('facilitiesGroupAll', false);
        }
    }, [formik.values.facilitiesGroup]);

    function AllClick(currentValue) {
        if (currentValue) {
            formik.setFieldValue('facilitiesGroupAll', false);
            formik.setFieldValue('facilitiesGroup', []);
        } else {
            formik.setFieldValue('facilitiesGroupAll', true);
            formik.setFieldValue('facilitiesGroup', [...formik.values.facilitiesGroupAllList]);
        }
    }

    return (<div>

        <Field name={'facilitiesGroupAll'}>
            {({ field, form }) => (
                <div className='other-field' style={{ display: 'flex', marginTop: 25, marginBottom: 25 }}>
                    <label className='paragraph' htmlFor="facilitiesGroupAll" style={{ fontFamily: 'Arial', color: 'black', fontSize: '1em', fontWeight: 600 }}>
                        <input type="checkbox" className='checkbox' id="facilitiesGroupAll"
                            checked={field.value ? true : false}
                            onChange={() => {
                            AllClick(field.value);
                        }} />
                        Request records from all locations</label>
                </div>
            )}
        </Field>
    </div>);
}

const Checkbox = props => {




    return (
        <Field name={props.name}>
            {({ field, form }) => (
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <label htmlFor={props.value} className='paragraph' style={props.style}>
                        <input
                            id={props.value}
                            type="checkbox"
                            {...props}
                            checked={field.value.includes(props.value)}
                            onChange={() => {
                                if (field.value.includes(props.value)) {
                                    // uncheck

                                    const nextValue = field.value.filter(
                                        value => value !== props.value
                                    );
                                    form.setFieldValue(props.name, nextValue);
                                } else {
                                    if (props.name === "sensitiveInfo" && props.value > 90) {

                                        const nextValue = [props.value];
                                        form.setFieldValue(props.name, nextValue);

                                    } else if (props.name === "sensitiveInfo" && props.value < 90) {
                                        const cleanArray = field.value.filter(
                                            value => value < 90
                                        );
                                        const nextValue = cleanArray.concat(props.value);
                                        form.setFieldValue(props.name, nextValue);
                                    }
                                    else {
                                        const nextValue = field.value.concat(props.value);
                                        const finalValue = nextValue.filter((value) => { return value !== 'allLocations' })
                                        form.setFieldValue(props.name, finalValue);
                                    }

                                }
                            }}
                        />
                        {props.label}</label>
                </div>
            )}
        </Field>
    );
};

export default Checkbox;

